import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drivr-auth-ui__password-reset-success-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "drivr-auth-ui__welcome" }, " You reset your password 🎉 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "drivr-auth-ui__introduction" }, " You can now log in with your username and your newly set password. ", -1)
const _hoisted_4 = { class: "drivr-auth-ui__form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ui_button, {
        class: "drivr-auth-ui__button",
        label: "Back to Login",
        variant: "primary",
        size: "default",
        type: "button",
        block: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
      })
    ])
  ]))
}